import React from 'react'
import { FaUserCog, FaNetworkWired } from 'react-icons/fa'
import { FaStethoscope } from "react-icons/fa";
import { MdOutlineShield } from "react-icons/md";
import './DigiHealthLandingService.css'

const DigiHealthLandingService = () => {
  return (
    <section className="Digi-Health-Landing-Service-section-bg">
      <div className="Digi-Health-Landing-Service-section-container">
        <div className="Digi-Health-Landing-Service-section-left">
          <h2 className="Digi-Health-Landing-Service-section-title">
            Transforming Healthcare<br />Through Collaboration
          </h2>
          <p className="Digi-Health-Landing-Service-section-desc">
            Acting as a neutral forum, DigiHealth India brings together stakeholder from all healthcare vocations—clinicians, technologists, administrators, policymakers, and patients—to advance the adoption of healthcare innovations and standards.
          </p>
          <p className="Digi-Health-Landing-Service-section-desc">
            Our independent, non-governmental approach ensures balanced perspectives across both public and private domains, fostering an environment where evidence-based solutions can flourish.
          </p>
          <div className="Digi-Health-Landing-Service-section-stats">
            <div>
              <span className="Digi-Health-Landing-Service-section-stat-number">500+</span>
              <span className="Digi-Health-Landing-Service-section-stat-label">Healthcare Professionals</span>
            </div>
            <div>
              <span className="Digi-Health-Landing-Service-section-stat-number Color-change-number">50+</span>
              <span className="Digi-Health-Landing-Service-section-stat-label">Partner Organizations</span>
            </div>
          </div>
        </div>
        <div className="Digi-Health-Landing-Service-section-right">
          <div className="Digi-Health-Landing-Service-section-cards">
            <div className="Digi-Health-Landing-Service-section-card">
              <FaStethoscope className="Digi-Health-Landing-Service-section-card-icon" />
              <div>
                <div className="Digi-Health-Landing-Service-section-card-title">Clinicians</div>
                <div className="Digi-Health-Landing-Service-section-card-desc">Medical professionals driving innovation</div>
              </div>
            </div>
            <div className="Digi-Health-Landing-Service-section-card">
              <FaUserCog className="Digi-Health-Landing-Service-section-card-icon" />
              <div>
                <div className="Digi-Health-Landing-Service-section-card-title">Administrators</div>
                <div className="Digi-Health-Landing-Service-section-card-desc">Healthcare system leaders</div>
              </div>
            </div>
            <div className="Digi-Health-Landing-Service-section-card">
              <FaNetworkWired className="Digi-Health-Landing-Service-section-card-icon" />
              <div>
                <div className="Digi-Health-Landing-Service-section-card-title">Technologists</div>
                <div className="Digi-Health-Landing-Service-section-card-desc">Digital health innovators</div>
              </div>
            </div>
            <div className="Digi-Health-Landing-Service-section-card">
              <MdOutlineShield className="Digi-Health-Landing-Service-section-card-icon" />
              <div>
                <div className="Digi-Health-Landing-Service-section-card-title">Policymakers</div>
                <div className="Digi-Health-Landing-Service-section-card-desc">Regulatory and policy experts</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default DigiHealthLandingService
